import { render, staticRenderFns } from "./CoMenuItem.vue?vue&type=template&id=14836685&scoped=true&"
import script from "./CoMenuItem.vue?vue&type=script&lang=ts&"
export * from "./CoMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./CoMenuItem.vue?vue&type=style&index=0&id=14836685&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14836685",
  null
  
)

export default component.exports